// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/restaurant/seating_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/restaurant/seating_preferences.proto.
 */
export const file_proto_model_booking_restaurant_seating_preferences = /*@__PURE__*/
  fileDesc("Cjhwcm90by9tb2RlbC9ib29raW5nL3Jlc3RhdXJhbnQvc2VhdGluZ19wcmVmZXJlbmNlcy5wcm90bxIGY2FybWVuIpkKChJTZWF0aW5nUHJlZmVyZW5jZXMSRgoScHJlZmVycmVkX2xvY2F0aW9uGAEgASgOMiouY2FybWVuLlNlYXRpbmdQcmVmZXJlbmNlcy5TZWF0aW5nTG9jYXRpb24SSQoUcHJlZmVycmVkX2F0dHJpYnV0ZXMYAiADKA4yKy5jYXJtZW4uU2VhdGluZ1ByZWZlcmVuY2VzLlNlYXRpbmdBdHRyaWJ1dGUSSgoTYW1iaWFuY2VfcHJlZmVyZW5jZRgDIAEoDjItLmNhcm1lbi5TZWF0aW5nUHJlZmVyZW5jZXMuQW1iaWFuY2VQcmVmZXJlbmNlElMKGmFjY2Vzc2liaWxpdHlfcmVxdWlyZW1lbnRzGAQgASgLMi8uY2FybWVuLlNlYXRpbmdQcmVmZXJlbmNlcy5BY2Nlc3NpYmlsaXR5U2VhdGluZxIaChJhdm9pZF9zZWF0aW5nX25lYXIYBSADKAkarQEKFEFjY2Vzc2liaWxpdHlTZWF0aW5nEh0KFXdoZWVsY2hhaXJfYWNjZXNzaWJsZRgBIAEoCBIcChRlYXN5X2FjY2Vzc19yZXF1aXJlZBgCIAEoCBIZChFoaWdoX2NoYWlyX25lZWRlZBgDIAEoCBIbChNib29zdGVyX3NlYXRfbmVlZGVkGAQgASgIEiAKGHNwZWNpYWxfZXF1aXBtZW50X25lZWRlZBgFIAMoCSKIAgoPU2VhdGluZ0xvY2F0aW9uEiAKHFNFQVRJTkdfTE9DQVRJT05fVU5TUEVDSUZJRUQQABIbChdTRUFUSU5HX0xPQ0FUSU9OX1dJTkRPVxABEhoKFlNFQVRJTkdfTE9DQVRJT05fUEFUSU8QAhIYChRTRUFUSU5HX0xPQ0FUSU9OX0JBUhADEhoKFlNFQVRJTkdfTE9DQVRJT05fQk9PVEgQBBIhCh1TRUFUSU5HX0xPQ0FUSU9OX1BSSVZBVEVfUk9PTRAFEiAKHFNFQVRJTkdfTE9DQVRJT05fTUFJTl9ESU5JTkcQBhIfChtTRUFUSU5HX0xPQ0FUSU9OX1FVSUVUX0FSRUEQByKDAgoQU2VhdGluZ0F0dHJpYnV0ZRIhCh1TRUFUSU5HX0FUVFJJQlVURV9VTlNQRUNJRklFRBAAEiEKHVNFQVRJTkdfQVRUUklCVVRFX1JPVU5EX1RBQkxFEAESIgoeU0VBVElOR19BVFRSSUJVVEVfU1FVQVJFX1RBQkxFEAISHgoaU0VBVElOR19BVFRSSUJVVEVfSElHSF9UT1AQAxIfChtTRUFUSU5HX0FUVFJJQlVURV9CQU5RVUVUVEUQBBIiCh5TRUFUSU5HX0FUVFJJQlVURV9DT1JORVJfVEFCTEUQBRIgChxTRUFUSU5HX0FUVFJJQlVURV9WSUVXX1RBQkxFEAYi8QEKEkFtYmlhbmNlUHJlZmVyZW5jZRIjCh9BTUJJQU5DRV9QUkVGRVJFTkNFX1VOU1BFQ0lGSUVEEAASHQoZQU1CSUFOQ0VfUFJFRkVSRU5DRV9RVUlFVBABEh4KGkFNQklBTkNFX1BSRUZFUkVOQ0VfTElWRUxZEAISIAocQU1CSUFOQ0VfUFJFRkVSRU5DRV9ST01BTlRJQxADEicKI0FNQklBTkNFX1BSRUZFUkVOQ0VfRkFNSUxZX0ZSSUVORExZEAQSLAooQU1CSUFOQ0VfUFJFRkVSRU5DRV9CVVNJTkVTU19BUFBST1BSSUFURRAFQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw");

/**
 * Describes the message carmen.SeatingPreferences.
 * Use `create(SeatingPreferencesSchema)` to create a new message.
 */
export const SeatingPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_restaurant_seating_preferences, 0);

/**
 * Describes the message carmen.SeatingPreferences.AccessibilitySeating.
 * Use `create(SeatingPreferences_AccessibilitySeatingSchema)` to create a new message.
 */
export const SeatingPreferences_AccessibilitySeatingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_restaurant_seating_preferences, 0, 0);

/**
 * Describes the enum carmen.SeatingPreferences.SeatingLocation.
 */
export const SeatingPreferences_SeatingLocationSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_restaurant_seating_preferences, 0, 0);

/**
 * @generated from enum carmen.SeatingPreferences.SeatingLocation
 */
export const SeatingPreferences_SeatingLocation = /*@__PURE__*/
  tsEnum(SeatingPreferences_SeatingLocationSchema);

/**
 * Describes the enum carmen.SeatingPreferences.SeatingAttribute.
 */
export const SeatingPreferences_SeatingAttributeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_restaurant_seating_preferences, 0, 1);

/**
 * @generated from enum carmen.SeatingPreferences.SeatingAttribute
 */
export const SeatingPreferences_SeatingAttribute = /*@__PURE__*/
  tsEnum(SeatingPreferences_SeatingAttributeSchema);

/**
 * Describes the enum carmen.SeatingPreferences.AmbiancePreference.
 */
export const SeatingPreferences_AmbiancePreferenceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_restaurant_seating_preferences, 0, 2);

/**
 * @generated from enum carmen.SeatingPreferences.AmbiancePreference
 */
export const SeatingPreferences_AmbiancePreference = /*@__PURE__*/
  tsEnum(SeatingPreferences_AmbiancePreferenceSchema);

